<script setup lang="ts">
/** [#e03fdbc2] Договор. Текст на русском как в документе владельца (п. 11.7), перевод — по запросу. */
import { ChevronRight, Info } from 'lucide-vue-next';
import contract from '@/content/contract.json';
import ContactBlock from './landing/ContactBlock.vue';
import PublicShell from './landing/PublicShell.vue';
import { usePublicPage } from './landing/usePublicPage';

const { copy, more, to } = usePublicPage();

/** «1. ПРЕДМЕТ ДОГОВОРА» в оглавлении читается легче обычным регистром. */
function tocTitle(title: string): string {
  const lower = title.toLowerCase().replace(/(^|\s)по(?=\s|$)/g, '$1ПО');
  return lower.charAt(0).toUpperCase() + lower.slice(1);
}
</script>

<template>
  <PublicShell>
    <main>
      <div class="lp-wrap lp-page lp-contract-top">
        <nav class="lp-crumbs" :aria-label="copy.articles.home">
          <RouterLink :to="to('/')">{{ copy.articles.home }}</RouterLink>
          <ChevronRight :size="14" /><span>{{ more.contract.title }}</span>
        </nav>
        <header class="lp-page-head">
          <h1>{{ more.contract.title }}</h1>
          <p>{{ more.contract.sub }}</p>
        </header>
        <p class="lp-limit lp-contract-note"><Info :size="16" />{{ more.contract.note }} <a href="#contact" class="lp-inline">{{ more.contract.translate }}</a></p>
      </div>
      <div class="lp-wrap lp-contract">
        <nav class="lp-toc" :aria-label="more.contract.toc">
          <h2>{{ more.contract.toc }}</h2>
          <ol>
            <li v-for="s in contract.sections" :key="s.n"><a :href="`#s${s.n}`">{{ s.n }}. {{ tocTitle(s.title) }}</a></li>
            <li><a href="#s12">12. {{ tocTitle(contract.signTitle) }}</a></li>
          </ol>
        </nav>
        <article class="lp-card lp-doc" lang="ru">
          <header>
            <h2>{{ contract.title }}</h2>
            <p class="lp-doc-sub">{{ contract.subtitle }}</p>
            <p class="lp-doc-place">{{ contract.place }}</p>
          </header>
          <p>{{ contract.intro }}</p>
          <section v-for="s in contract.sections" :id="`s${s.n}`" :key="s.n">
            <h3>{{ s.n }}. {{ tocTitle(s.title) }}</h3>
            <div v-for="item in s.items" :key="item.n" class="lp-clause">
              <span>{{ item.n }}</span>
              <div>
                <p v-for="(para, i) in item.text.split('\n')" :key="i">{{ para }}</p>
                <ul v-if="item.list.length"><li v-for="li in item.list" :key="li">{{ li }}</li></ul>
              </div>
            </div>
          </section>
          <section id="s12">
            <h3>12. {{ tocTitle(contract.signTitle) }}</h3>
            <div class="lp-sign">
              <div v-for="p in contract.parties" :key="p.title">
                <h4>{{ p.title }}</h4>
                <p v-for="(line, i) in p.lines" :key="i">{{ line }}</p>
              </div>
            </div>
          </section>
        </article>
      </div>
      <ContactBlock :title="more.contract.formTitle" :sub="more.contract.formSub" :button="more.contract.formButton" />
    </main>
  </PublicShell>
</template>
